import { useL10n } from '@uplift/hooks';
import { TextInput } from '@uplift/ui-v2';
import { useProfileStyles } from '../styles';

export const WorkEmailForm: React.VFC = () => {
  const { classes } = useProfileStyles();
  const l10n = useL10n();

  return (
    <div>
      <TextInput
        name="workEmail"
        helperText={l10n.providerSettings.emailDisplayedToYourClients}
        errorTextFirst
        fullWidth
        inputClasses={{ root: classes.maxWidth400 }}
      />
    </div>
  );
};
